
import { Component, Vue } from 'vue-property-decorator'
import ButtonPulldown from '@/components/molecules/ButtonPulldown.vue'

/**
 * 選択系汎用ボタン
 */
@Component({
  components: {
    ButtonPulldown,
  },
})
export default class SelectPulldownButton extends Vue {
  /**
   * クリックイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private clickEvent(event: Event): void {
    this.$emit('click', event)
  }
}
